import { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { fetchFromApi } from "../utils/fetchFromApi.js";
import { MuiVideos } from "./";
import { useParams } from "react-router-dom";

const MuiSearch = () => {
  const [videos, setVideos] = useState([]);
  const { searchItem } = useParams();

  useEffect(() => {
    fetchFromApi(`search?part=snippet&q=${searchItem}`).then((data) =>
      setVideos(data.items)
    );
  }, [searchItem]);

  return (
    <Box p={2} sx={{ overflowY: "auto", height: "90vh", flex: 2 }}>
      <Typography variant="h4" fontWeight="bold" mb={2} sx={{ color: "white" }}>
        You Search "<span style={{ color: "red" }}>{searchItem}</span>"
      </Typography>
        <MuiVideos videos={videos} />
    </Box>
  );
};

export default MuiSearch;
